/* ==========================================================================
   LK Collection V4 — comportements
   Amélioration progressive : sans ce fichier la page reste complète et
   navigable (liens de filtres, pagination par lien, fiches produit).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__LKC4__) return;
  window.__LKC4__ = true;

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var LOCALE = document.documentElement.lang || 'fr-FR';
  var MONEY_FORMAT = null;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* On reproduit le format monétaire de la boutique pour rester cohérent
     avec les prix rendus par Liquid (| money). Sans format, repli Intl. */
  function money(cents) {
    if (MONEY_FORMAT) {
      var withComma = (cents / 100).toFixed(2).replace('.', ',');
      var withDot = (cents / 100).toFixed(2);
      var noDec = String(Math.round(cents / 100));
      return MONEY_FORMAT.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (_, key) {
        if (key === 'amount' || key === 'amount_with_comma_separator') return withComma;
        if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') return noDec;
        return withDot;
      });
    }
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + CURRENCY;
    }
  }

  function qs(root, sel) { return root ? root.querySelector(sel) : null; }
  function qsa(root, sel) { return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }

  /* ------------------------------------------------------- <dialog> utils */
  var lastFocus = null;

  function openDialog(dlg) {
    if (!dlg || dlg.open) return;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('lkc4-lock');
    if (typeof dlg.showModal === 'function') {
      try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    } else {
      dlg.setAttribute('open', '');
    }
  }

  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') { try { dlg.close(); } catch (e) {} }
    dlg.removeAttribute('open');
    if (!document.querySelector('dialog.lkc4-qv[open], dialog.lkc4-filterDrawer[open]')) {
      document.documentElement.classList.remove('lkc4-lock');
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  /* --------------------------------------------------------------- toast */
  var toastTimer = null;
  function toast(root, text) {
    var el = qs(root, '[data-lkc4-toast]');
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 1800);
  }

  /* ================================================================== */
  /* Sur les pages collection, l'ajout au panier ne doit PAS ouvrir le
     tiroir automatiquement : le retour visuel = toast + vol de vignette +
     barre panier collante. En revanche, un clic VOLONTAIRE sur l'icône
     panier du header (ou le CTA de la barre) doit ouvrir le tiroir.
     -> on wrappe cart-drawer.open en conservant l'original, et on ne
     laisse passer que les ouvertures précédées d'une INTENTION explicite
     (clic sur l'icône panier / CTA barre, horodaté dans
     window.__lkc4CartIntent). Une fenêtre temporelle après ajout serait
     une course perdante : un /cart/add.js lent rouvrirait le tiroir. */
  var CART_INTENT_MS = 1500;

  function markCartIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#cart-icon-bubble') || t.closest('[data-lkc4-sticky-cta]')) {
      window.__lkc4CartIntent = Date.now();
    }
  }

  function tameCartDrawer() {
    /* capture : passe avant les listeners Dawn posés sur l'icône elle-même */
    document.addEventListener('pointerdown', markCartIntent, true);
    document.addEventListener('click', markCartIntent, true);
    var apply = function () {
      var cd = document.querySelector('cart-drawer');
      if (!cd || cd.__lkc4Tamed) return;
      if (typeof cd.open !== 'function') return; // custom element pas encore upgradé
      cd.__lkc4Tamed = true;
      var openOriginal = cd.open.bind(cd);
      cd.__lkc4Open = openOriginal; // ouverture volontaire garantie (CTA barre panier)
      cd.open = function () {
        var want = window.__lkc4CartIntent || 0;
        if (!want || Date.now() - want > CART_INTENT_MS) return; // ouverture non sollicitée : ignorée
        return openOriginal.apply(null, arguments);
      };
    };
    apply();
    if (window.customElements && typeof customElements.whenDefined === 'function') {
      try { customElements.whenDefined('cart-drawer').then(apply); } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  }

  /* --------------------------- vol de la vignette vers l'icône panier --- */
  function flyToCart(fromEl) {
    if (REDUCED || !fromEl) return;
    var target =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[href$="/cart"]');
    if (!target) return;

    var from = fromEl.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var ghost = document.createElement('img');
    ghost.src = fromEl.currentSrc || fromEl.src;
    ghost.alt = '';
    ghost.className = 'lkc4-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    ghost.style.opacity = '1';
    document.body.appendChild(ghost);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ghost.style.left = to.left + to.width / 2 - 14 + 'px';
        ghost.style.top = to.top + to.height / 2 - 14 + 'px';
        ghost.style.width = '28px';
        ghost.style.height = '28px';
        ghost.style.opacity = '0.25';
        ghost.style.transform = 'rotate(12deg)';
      });
    });

    setTimeout(function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      target.classList.add('lkc4-cartPop');
      setTimeout(function () { target.classList.remove('lkc4-cartPop'); }, 420);
    }, 640);

    if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
  }

  /* ===================================================================== */
  function initSection(root) {
    if (root.dataset.lkc4Init === '1') return;
    root.dataset.lkc4Init = '1';

    var sectionId = root.dataset.sectionId;
    var threshold = parseInt(root.dataset.freeShipping || '0', 10);
    var cartUrl = root.dataset.cartUrl || '/cart';
    if (root.dataset.moneyFormat) MONEY_FORMAT = root.dataset.moneyFormat;

    tameCartDrawer();

    /* ------------------------------------------------ hauteur du header */
    function syncHeaderHeight() {
      var header =
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('#shopify-section-header');
      var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
      if (h > 0 && h < 200) root.style.setProperty('--lkc4-header-h', h + 'px');
    }
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight, { passive: true });

    /* ---------------------------------------- masquage barre au scroll */
    var lastScroll = window.scrollY;

    /* ============================== navigation filtrée (AJAX) ========= */
    var isNavigating = false;
    var pendingNav = null; /* LK 10/09 : un choix fait pendant un chargement n'est plus perdu (url + mode) */
    var renderedUrl = window.location.pathname + window.location.search; /* état réellement affiché */

    /* LK 10/09 : l'entrée d'historique INITIALE est marquée, sinon Retour vers elle ne
       restaure pas la grille (bug reproduit : tri prix croissant → Retour → URL sans
       sort_by mais produits encore triés). L'état posé par d'autres composants est conservé. */
    try {
      var st0 = window.history.state;
      if (!(st0 && st0.lkc4)) {
        var merged = {}; if (st0 && typeof st0 === 'object') { for (var k in st0) merged[k] = st0[k]; }
        merged.lkc4 = true;
        window.history.replaceState(merged, '', window.location.href);
      }
    } catch (e0) {}

    /* LK 10/09 : puces « raccourcis » liées à un filtre de cette collection — état actif
       synchronisé avec l'URL, second appui = retire le filtre. */
    function syncQuickChips() {
      var cur = new URL(window.location.href);
      var colPath = root.dataset.collectionUrl || cur.pathname;
      qsa(root, '.lkc4__quickChip').forEach(function (a) {
        if (a.hasAttribute('data-lkc4-facet')) return; /* puces natives : URLs déjà fusionnées par Shopify */
        var raw = a.getAttribute('data-lkc4-chip-url') || a.getAttribute('href');
        if (!a.getAttribute('data-lkc4-chip-url')) a.setAttribute('data-lkc4-chip-url', raw);
        var u; try { u = new URL(raw, window.location.origin); } catch (e2) { return; }
        var keys = []; u.searchParams.forEach(function (v, k) { keys.push([k, v]); });
        if (u.pathname !== colPath || !keys.length) return; /* autre collection ou ancre : lien classique */
        a.setAttribute('data-lkc4-nav', '');
        var on = u.pathname === cur.pathname;
        keys.forEach(function (kv) { if (cur.searchParams.get(kv[0]) !== kv[1]) on = false; });
        /* fusion avec l'état courant (tri, autres filtres conservés) ; second appui = retire seulement ses paramètres */
        var target = new URL(cur.href); target.searchParams.delete('page');
        keys.forEach(function (kv) { if (on) target.searchParams.delete(kv[0]); else target.searchParams.set(kv[0], kv[1]); });
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        a.setAttribute('href', target.pathname + target.search);
      });
    }
    syncQuickChips();

    function withSectionId(url) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    }

    function swap(selector, doc) {
      var next = qs(doc, selector);
      var current = qs(root, selector);
      if (current && next) { current.innerHTML = next.innerHTML; return true; }
      if (current && !next) current.innerHTML = '';
      return false;
    }

    function navigate(url, push) {
      if (isNavigating) { pendingNav = { url: url, push: push }; return; }
      isNavigating = true;
      var grid = qs(root, '[data-lkc4-grid]');
      if (grid) grid.classList.add('is-loading');

      fetch(withSectionId(url), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          swap('[data-lkc4-grid]', doc);
          swap('[data-lkc4-active-filters]', doc);
          swap('[data-lkc4-toolbar]', doc);
          swap('[data-lkc4-filter-drawer]', doc);
          swap('[data-lkc4-sort-sheet]', doc); /* LK 10/09 : coche du tri resynchronisée */
          swap('[data-lkc4-quick]', doc); /* LK 10/09 : puces de familles (compteurs, état actif) */
          var qn = qs(root, '[data-lkc4-quick]'); if (qn) qn.hidden = !qn.children.length;
          try { var ru = new URL(url, window.location.origin); renderedUrl = ru.pathname + ru.search; } catch (e1) {}

          var nextMore = qs(doc, '[data-lkc4-more]');
          var curMore = qs(root, '[data-lkc4-more]');
          if (nextMore && curMore) curMore.innerHTML = nextMore.innerHTML;
          else if (nextMore && !curMore) qs(root, '[data-lkc4-grid]').insertAdjacentHTML('afterend', nextMore.outerHTML);
          else if (!nextMore && curMore) curMore.remove();

          if (push !== false) window.history.pushState({ lkc4: true }, '', url);
          syncQuickChips();
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          isNavigating = false;
          var g = qs(root, '[data-lkc4-grid]');
          if (g) g.classList.remove('is-loading');
          if (pendingNav) { var next = pendingNav; pendingNav = null; navigate(next.url, next.push); }
        });
    }

    window.addEventListener('popstate', function (e) {
      /* LK 10/09 : Retour/Avance vers n'importe quel état de CETTE collection recharge la
         grille (entrée initiale comprise, marquée ci-dessus). */
      var now = window.location.pathname + window.location.search;
      if (now === renderedUrl) return; /* simple ancre (#...) ou état déjà affiché : rien à recharger */
      var onCollection = window.location.pathname === (root.dataset.collectionUrl || window.location.pathname);
      if ((e.state && e.state.lkc4) || onCollection) navigate(window.location.href, false);
    });

    /* ------------------------------------ interception liens & filtres */
    root.addEventListener('click', function (e) {
      var navLink = e.target.closest('[data-lkc4-nav]');
      if (navLink && navLink.getAttribute('href')) {
        e.preventDefault();
        closeDialog(qs(root, '[data-lkc4-filter-drawer]'));
        navigate(navLink.getAttribute('href'));
      }
    });

    root.addEventListener('change', function (e) {
      var box = e.target.closest('[data-lkc4-filter-value]');
      if (box && box.dataset.url) { navigate(box.dataset.url); return; }

      var sort = e.target.closest('[data-lkc4-sort]');
      if (sort) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        navigate(u.pathname + u.search);
      }
    });

    function applyPrice() {
      var min = qs(root, '[data-lkc4-price-min]');
      var max = qs(root, '[data-lkc4-price-max]');
      if (!min && !max) return;
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      if (min && min.value !== '') u.searchParams.set('filter.v.price.gte', min.value);
      else u.searchParams.delete('filter.v.price.gte');
      if (max && max.value !== '') u.searchParams.set('filter.v.price.lte', max.value);
      else u.searchParams.delete('filter.v.price.lte');
      closeDialog(qs(root, '[data-lkc4-filter-drawer]'));
      navigate(u.pathname + u.search);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lkc4-price-apply]')) { e.preventDefault(); applyPrice(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-lkc4-price-min],[data-lkc4-price-max]')) {
        e.preventDefault();
        applyPrice();
      }
    });

    /* ---------------------------------------------------- « voir plus » */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lkc4-more-btn]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('href');
      if (!url || btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';
      var label = btn.textContent;
      btn.textContent = 'Chargement…';

      fetch(withSectionId(url), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = qs(root, '[data-lkc4-grid]');
          var seen = {};
          qsa(grid, '[data-lkc4-card]').forEach(function (c) { seen[c.dataset.handle] = 1; });
          qsa(doc, '[data-lkc4-grid] [data-lkc4-card]').forEach(function (c) {
            if (!seen[c.dataset.handle]) grid.appendChild(c);
          });

          var nextMore = qs(doc, '[data-lkc4-more]');
          var curMore = qs(root, '[data-lkc4-more]');
          if (nextMore && curMore) curMore.innerHTML = nextMore.innerHTML;
          else if (curMore) curMore.remove();

          window.history.replaceState({ lkc4: true }, '', url);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          btn.dataset.busy = '';
          if (btn.isConnected) btn.textContent = label;
        });
    });

    /* -------------------------------------------------- tiroir filtres */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lkc4-filter-open]')) {
        openDialog(qs(root, '[data-lkc4-filter-drawer]'));
      }
    });

    /* ---------------------------------------------------- tiroir de tri */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lkc4-sort-open]')) {
        openDialog(qs(root, '[data-lkc4-sort-sheet]'));
        return;
      }
      var sortOpt = e.target.closest('[data-lkc4-sort-value]');
      if (sortOpt) {
        qsa(root, '[data-lkc4-sort-value]').forEach(function (b) { b.removeAttribute('aria-current'); });
        sortOpt.setAttribute('aria-current', 'true');
        closeDialog(qs(root, '[data-lkc4-sort-sheet]'));
        var su = new URL(window.location.href);
        su.searchParams.set('sort_by', sortOpt.dataset.lkc4SortValue);
        su.searchParams.delete('page');
        navigate(su.pathname + su.search);
      }
    });

    /* --------------------------- description SEO : lire la suite/réduire */
    var rmWrap = qs(root, '[data-lkc4-readmore]');
    var rmBtn = qs(root, '[data-lkc4-readmore-btn]');
    if (rmWrap && rmBtn) {
      var rmInner = qs(rmWrap, '.lkc4__proseRichInner');
      var syncReadMore = function () {
        if (rmWrap.classList.contains('is-open')) return;
        var needsClamp = !!(rmInner && rmInner.scrollHeight > 520);
        rmWrap.classList.toggle('is-clamped', needsClamp);
        rmBtn.hidden = !needsClamp;
      };
      syncReadMore();
      window.addEventListener('resize', syncReadMore, { passive: true });
      rmBtn.addEventListener('click', function () {
        var open = rmWrap.classList.toggle('is-open');
        rmWrap.classList.toggle('is-clamped', !open);
        rmBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var rmLabel = qs(rmBtn, '[data-lkc4-readmore-label]');
        if (rmLabel) rmLabel.textContent = open ? 'Réduire' : 'Lire la suite';
        if (!open) rmWrap.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ======================================================= Quick View */
    var qvCache = {};
    var qvDialog = qs(root, '[data-lkc4-qv-dialog]');
    var qvBody = qs(qvDialog, '[data-lkc4-qv-body]');

    /* résumé allergènes déduit du bloc ingrédients, comme sur Compose ta Box */
    function fillAllergenSummary() {
      var slot = qs(qvBody, '[data-lkc4-qv-allsum]');
      var inco = qs(qvBody, '[data-lkc4-qv-inco-body]');
      if (!slot) return;
      if (!inco) { slot.hidden = true; return; }
      var txt = inco.textContent || '';
      var m = txt.match(/Allerg[èe]nes?\s*:?\s*([^.]{3,140})/i);
      if (m) {
        slot.hidden = false;
        slot.textContent = 'Allergènes : ' + m[1].trim();
      } else {
        slot.hidden = true;
      }
    }

    /* pagination de la galerie swipe */
    function bindGallery() {
      var track = qs(qvBody, '[data-lkc4-qv-track]');
      var dots = qsa(qvBody, '[data-lkc4-qv-dot]');
      if (!track || dots.length < 2) return;

      function sync() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, idx) {
          if (idx === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      track.addEventListener('scroll', function () {
        window.clearTimeout(track.__t);
        track.__t = window.setTimeout(sync, 60);
      }, { passive: true });

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * Number(d.dataset.lkc4QvDot), behavior: 'smooth' });
        });
      });
    }

    function openQuickView(handle, card) {
      if (!qvDialog || !qvBody) return;

      var title = card ? card.dataset.title : '';
      var img = card ? card.dataset.image : '';
      qvBody.innerHTML =
        '<div class="lkc4-qv__inner" style="grid-template-columns:1fr">' +
        '<button type="button" class="lkc4-qv__close" data-lkc4-close aria-label="Fermer">×</button>' +
        (img ? '<div class="lkc4-qv__media"><div class="lkc4-qv__track"><div class="lkc4-qv__slide"><img src="' + img + '" alt="" /></div></div></div>' : '') +
        '<div class="lkc4-qv__body"><h3 class="lkc4-qv__title">' + (title || '') + '</h3>' +
        '<p class="lkc4-qv__skeleton">Chargement des informations produit…</p></div></div>';
      qvBody.setAttribute('aria-busy', 'true');
      openDialog(qvDialog);

      var render = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var panel = qs(doc, '[data-lkc4-qv-panel]');
        if (panel) qvBody.innerHTML = panel.outerHTML;
        qvBody.setAttribute('aria-busy', 'false');
        fillAllergenSummary();
        bindGallery();
      };

      if (qvCache[handle]) { render(qvCache[handle]); return; }

      fetch('/products/' + encodeURIComponent(handle) + '?section_id=lk-quickview', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) { qvCache[handle] = html; render(html); })
        .catch(function () {
          closeDialog(qvDialog);
          window.location.href = '/products/' + handle;
        });
    }

    /* vignette, icône œil et titre ouvrent tous les trois l'aperçu */
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lkc4-qv]');
      if (!opener) return;
      e.preventDefault();
      e.stopPropagation();
      openQuickView(opener.dataset.lkc4Qv, opener.closest('[data-lkc4-card]'));
    });

    /* changement de variante dans le Quick View */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lkc4-qv-variant]');
      if (!sel) return;
      var opt = sel.options[sel.selectedIndex];
      var priceEl = qs(qvBody, '[data-lkc4-qv-price]');
      var stockEl = qs(qvBody, '[data-lkc4-qv-stock]');
      var atc = qs(qvBody, '[data-lkc4-qv-add]');
      var available = opt.dataset.available === 'true';

      if (priceEl) priceEl.innerHTML = opt.dataset.price + (opt.dataset.compare ? '<s>' + opt.dataset.compare + '</s>' : '');
      if (stockEl) {
        stockEl.textContent = available ? (stockEl.getAttribute('data-label-ok') || 'Disponible · expédition 24/48 h') : 'Bientôt de retour';
        stockEl.classList.toggle('is-out', !available);
      }
      if (atc) {
        atc.dataset.variantId = opt.value;
        atc.disabled = !available;
        atc.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      }
    });

    /* ----------------------------------------------- alerte retour stock */
    var notifyDialog = qs(root, '[data-lkc4-notify-dialog]');
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lkc4-notify]');
      if (!btn || !notifyDialog) return;
      e.preventDefault();
      var titleEl = qs(notifyDialog, '[data-lkc4-notify-title]');
      var hidden = qs(notifyDialog, '[data-lkc4-notify-product]');
      if (titleEl) titleEl.textContent = btn.dataset.title || 'ce produit';
      if (hidden) hidden.value = (btn.dataset.title || '') + ' (' + (btn.dataset.handle || '') + ')';
      closeDialog(qvDialog);
      openDialog(notifyDialog);
    });

    /* ------------------------------------------------ fermeture dialogs */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lkc4-close]')) {
        closeDialog(e.target.closest('dialog'));
        return;
      }
      // clic sur le fond du <dialog> (padding:0 => la boîte == le contenu)
      if (e.target.tagName === 'DIALOG') closeDialog(e.target);
    });
    qsa(root, 'dialog').forEach(function (d) {
      d.addEventListener('cancel', function () {
        document.documentElement.classList.remove('lkc4-lock');
      });
      d.addEventListener('close', function () {
        if (!document.querySelector('dialog.lkc4-qv[open], dialog.lkc4-filterDrawer[open]')) {
          document.documentElement.classList.remove('lkc4-lock');
        }
      });
    });

    /* ============================================ barre panier « signature » */
    /* Pilule flottante PERMANENTE (verre dépoli) : résumé « N gourmandises ·
       montant », ligne livraison offerte à pastille (→ rose en progression,
       ✓ mint une fois débloquée), fine barre de progression rose en pied de
       pilule, célébration au seuil atteint. Ni masquage au scroll ni croix. */
    var sticky = qs(root, '[data-lkc4-sticky]');
    var stickyState = { celebrated: false };

    function renderCart(cart) {
      if (!sticky) return;
      var count = cart && cart.item_count ? cart.item_count : 0;
      var total = cart && cart.total_price ? cart.total_price : 0;
      var ratio = threshold > 0 ? Math.min(total / threshold, 1) : 1;
      var remaining = Math.max(threshold - total, 0);
      var pct = Math.min(Math.round(ratio * 100), 100);

      var fill = qs(sticky, '[data-lkc4-sticky-fill]');
      var amount = qs(sticky, '[data-lkc4-sticky-amount]');
      var summary = qs(sticky, '[data-lkc4-sticky-summary]');
      var message = qs(sticky, '[data-lkc4-sticky-message]');

      if (fill) fill.style.width = pct + '%';

      var reached = count > 0 && remaining === 0 && !over;
      sticky.classList.toggle('is-empty', count === 0);
      sticky.classList.toggle('is-reached', reached);

      /* ligne reward : pastille (→ ou ✓) + texte, toujours la même structure */
      function reward(dot, html) {
        if (!message) return;
        message.innerHTML =
          '<span class="lkc4-sticky__dot" aria-hidden="true">' + dot + '</span>' +
          '<span>' + html + '</span>';
      }

      if (count === 0) {
        stickyState.celebrated = false;
        if (summary) summary.textContent = 'Livraison offerte dès ' + money(threshold);
        if (amount) amount.hidden = true;
        reward('→', 'Ajoute tes premiers snacks pour lancer le compteur');
        return;
      }

      if (summary) summary.textContent = count + ' gourmandise' + (count > 1 ? 's' : '');
      if (amount) {
        amount.textContent = money(total);
        amount.hidden = false;
      }

      if (reached) {
        reward('✓', 'Livraison offerte débloquée 🎉');
        if (!stickyState.celebrated) {
          stickyState.celebrated = true;
          sticky.classList.remove('is-celebrate');
          void sticky.offsetWidth; /* relance l'animation à chaque déblocage */
          sticky.classList.add('is-celebrate');
        }
      } else {
        stickyState.celebrated = false;
        var lead = ratio >= 0.7 ? 'Tu y es presque — plus que ' : 'Plus que ';
        reward('→', lead + '<strong>' + money(remaining) + '</strong> pour la livraison offerte');
      }
    }

    if (sticky) {
      /* clic volontaire : ouvre le vrai cart drawer (repli : page panier) */
      qs(sticky, '[data-lkc4-sticky-cta]').addEventListener('click', function () {
        var cd = document.querySelector('cart-drawer');
        var openFn = cd && (cd.__lkc4Open || cd.open);
        if (cd && typeof openFn === 'function') {
          window.__lkc4CartIntent = Date.now();
          openFn.call(cd);
        } else {
          window.location.href = cartUrl;
        }
      });

      /* En preview de thème, la barre Shopify « Draft » recouvre le bas de
         l'écran : on remonte la barre panier au-dessus. Sans effet en
         production (l'iframe de preview n'existe pas). */
      function liftAboveShopifyPreviewBar() {
        if (document.getElementById('PBarNextFrame')) sticky.style.bottom = '76px';
      }
      liftAboveShopifyPreviewBar();
      setTimeout(liftAboveShopifyPreviewBar, 1500);
    }

    var refreshTimer = null;
    function refreshCart(delay) {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        fetch(cartUrl + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .catch(function () {});
      }, delay || 0);
    }
    refreshCart(0);

    /* --- retour visuel d'ajout : bump, vol vers le panier, toast, barre ---
       Feedback transitoire uniquement : aucun état persistant posé sur la
       carte (l'ajout réel est géré par lk-cart-drawer.js). */
    document.addEventListener(
      'pointerdown',
      function (e) {
        var btn = e.target.closest && e.target.closest('.lk7__atc:not(.lk7__atc--notify)');
        if (!btn || !root.contains(btn)) return;

        var card = btn.closest('[data-lkc4-card]');
        var srcImg = null;

        if (card) {
          srcImg = card.querySelector('.lkc4__media img');
          card.classList.add('is-bump');
          setTimeout(function () { card.classList.remove('is-bump'); }, 380);
        } else if (qvBody && qvBody.contains(btn)) {
          srcImg = qvBody.querySelector('.lkc4-qv__slide img');
        }

        if (srcImg) flyToCart(srcImg);
        refreshCart(1100);
        toast(root, 'Ajouté au panier');
      },
      true
    );

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(120); }); } catch (e) {}
    }
    document.addEventListener('cart:refresh', function () { refreshCart(120); });

    /* --------------------------- scroll : barre d'outils + barre panier */
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        var wrap = qs(root, '[data-lkc4-toolbar]');
        if (wrap) {
          if (y > 260 && y > lastScroll + 7) wrap.classList.add('is-hidden');
          else if (y < lastScroll - 5) wrap.classList.remove('is-hidden');
        }
        /* barre panier permanente : aucune logique de masquage au scroll */
        lastScroll = y;
      },
      { passive: true }
    );
  }

  function boot() {
    qsa(document, '[data-lkc4]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
